import Vue from 'vue'
import Vuex from 'vuex'
import { getSystemConfig } from '@/api'

Vue.use(Vuex)

// 登录状态持久化，刷新页面后仍能保持
const USER_KEY = 'user_info'
const savedUser = (() => {
  try {
    const str = localStorage.getItem(USER_KEY)
    return str ? JSON.parse(str) : null
  } catch (e) {
    return null
  }
})()

export default new Vuex.Store({
  state: {
    userInfo: savedUser,
    // 系统配置（来自 getSystemConfig 接口）
    systemConfig: {
      tel: '',
      web_company_name: '',
      web_site_address: '',
      web_site_description: '',
      web_site_email: '',
      whatsapp: ''
    },
    // 系统配置是否已加载
    systemConfigLoaded: false
  },
  mutations: {
    setUserInfo(state, info) {
      state.userInfo = info
      try {
        localStorage.setItem(USER_KEY, JSON.stringify(info))
      } catch (e) { }
    },
    clearUserInfo(state) {
      state.userInfo = null
      try {
        localStorage.removeItem(USER_KEY)
      } catch (e) { }
    },
    setSystemConfig(state, config) {
      state.systemConfig = { ...state.systemConfig, ...(config || {}) }
      state.systemConfigLoaded = true
    }
  },
  getters: {
    userInfo: state => state.userInfo,
    isLoggedIn: state => !!state.userInfo,
    systemConfig: state => state.systemConfig,
    // 便捷取值：公司名称 / 电话 / 地址 / 站点描述 / 邮箱 / WhatsApp
    companyName: state => state.systemConfig.web_company_name,
    contactTel: state => state.systemConfig.tel,
    contactAddress: state => state.systemConfig.web_site_address,
    siteDescription: state => state.systemConfig.web_site_description,
    siteEmail: state => state.systemConfig.web_site_email,
    whatsapp: state => state.systemConfig.whatsapp
  },
  actions: {
    // 全局拉取系统配置（只请求一次），按 name 字段映射，兼容 title 为中文的情况
    // 兼容两种返回结构：嵌套 { data: { sys:[...], time_zone } } 或 扁平 [ { title, name, value } ]
    async fetchSystemConfig({ state, commit }) {
      if (state.systemConfigLoaded) return state.systemConfig
      const codes = 'sys,time_zone'
      try {
        const res = await getSystemConfig({ code: codes })
        if (res.code == '1' && res.data) {
          const data = res.data
          const sysList = Array.isArray(data) ? data : (data.sys || [])
          const map = {}
          sysList.forEach(item => {
            const key = item.name || ''
            if (key) map[key] = item.value
          })
          commit('setSystemConfig', map)
          return state.systemConfig
        }
      } catch (e) {
        console.error('fetchSystemConfig failed', e)
      }
      return state.systemConfig
    }
  }
})
